import React from "react";
import { Grid, Container, Typography, Box } from "@mui/material";
import CourseCard from "./CourseCard";
import GCPImage from '../assets/images/GCP.jpg';
import AzureImage from '../assets/images/Azure.jpg';
import AWS from '../assets/images/AWS.jpg';
import snowFlakeImage from '../assets/images/snowFlake.jpg';
import fullStackImage from '../assets/images/fullStack.jpg';
import bigDataImage from '../assets/images/bigData.jpg';
import TestimonialsCarousel from '../components/TestimonialsCarousel';

const coursesData = [
  {
    id: 'azure-data-engineering-training',
    image: AzureImage,
    title: "Azure Data Engineering Training",
    rating: 4.5,
    reviews: "1k",
    duration: "2-4 Months",
    hours: "50+",
    batch: "21st March",
    fees: "15,000 - 25,000",
  },
  {
    id: "gcp-professional-certification-training",
    image: GCPImage, 
    title: "GCP Professional Certification Training",
    rating: 4.8,
    reviews: "1.8k",
    duration: "2 Months",
    hours: "45+",
    batch: "14th March",
    fees: "20,000",
  }, 
  {
    id: "aws-data-engineering-training",
    image: AWS,
    title: "AWS Data Engineering Training",
    rating: 4.9,
    reviews: "5k",
    duration: "50+ Hours",
    hours: "50+",
    batch: "Started",
    fees: "15,000",
  },
  {
    id: "snowflake-data-engineering-training",
    image: snowFlakeImage,
    title: "Snowflake Data Engineering Training",
    rating: 5.0,
    reviews: "500",
    duration: "2 Months",
    hours: "60+",
    batch: "Started",
    fees: "9,999 - 29,999",
  },
  {
    id: "full-stack-data-engineering-training",
    image: fullStackImage,
    title: "Full stack Data Engineering Training",
    rating: 5.0,
    reviews: "500",
    duration: "3-6 Months",
    hours: "60+",
    batch: "Started",
    fees: "34,999 - 59,999",
  },
  {
    id: "big-data-engineering-training",
    image: bigDataImage,
    title: "Big Data Engineering Training",
    rating: 5.0,
    reviews: "500",
    duration: "2 Months",
    hours: "60+",
    batch: "Started",
    fees: "9,999 - 29,999",
  },
];

const Courses = () => {
  return (
    <Box sx={{ backgroundColor: "#f8f9fa" }}  >
    <Container sx={{ textAlign: "center", py: 5  }}>
      <Typography variant="h4" fontWeight="bold">
        Software Trainings <span style={{ color: "red" }}>We Offer</span>
      </Typography>
      <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
        Do check the batch starting date & timing before joining any training.
      </Typography>

      <Grid container spacing={3} justifyContent="left">
        {coursesData.map((course, index) => (
          <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
            <CourseCard course={course} />
          </Grid>
        ))}
      </Grid>
      <TestimonialsCarousel />
    </Container>
    </Box>
  );
};

export default Courses;
